import { yupResolver } from "@hookform/resolvers/yup";
import React, { useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useRouter } from "next/router";

import { useTranslation } from "../../../core/translation.core";
import { useAddCustomer } from "../../../hooks/services/useCustomers";
import BackIcon from "../../../icons/back.icon";
import { createPosCustomerValidationSchema } from "../../customer/validations";
import { FancyLabelAndInput } from "../../reuseables/form.comp";
import useAdminShop from "../../../hooks/useAdminShop";
import { getPosCustomer } from "../../../core/posCustomer.core";
import useNavToNewOrder from "../../../hooks/useNavToNewOrder";

interface IProps {
  setChooseOption: any;
  showAddCustomer: any;
}

interface FormType {
  email?: string | undefined;
  remarks?: string | undefined;
  refNumber?: string | undefined;
  regType?: string | undefined;
  mobileNumber?: string | undefined;
  firstName: string;
  lastName: string;
}

export default function AddNewCustomer({ setChooseOption, showAddCustomer }: IProps) {
  const { t, msg } = useTranslation();
  const shop = useAdminShop();
  const navToNewOrder = useNavToNewOrder();

  const methods = useForm<FormType>({
    resolver: yupResolver(createPosCustomerValidationSchema(t, msg)),
  });

  useEffect(() => {
    // @ts-ignore
    methods.setValue("regType", shop.regType);
  }, [shop, methods]);

  const addCustomer = useAddCustomer();

  function handleBack() {
    setChooseOption(true);
    showAddCustomer(false);
  }

  async function onSubmit(data: FormType) {
    try {
      const response = await addCustomer.mutateAsync(data);

      if (response && response.userId) {
        toast.success(t(msg.customer.customerAdded));

        const customer = await getPosCustomer(response.userId);

        navToNewOrder(customer, () => {
          setChooseOption(true);
          showAddCustomer(false);
        });
      }
    } catch (error) {
      toast.error(addCustomer.error?.message);
    }
  }

  return (
    <div className="space-y-8 px-5 pb-10">
      <button onClick={handleBack} className="flex items-center gap-4">
        <BackIcon />
        <h1 className="text-xl font-medium">Back</h1>
      </button>

      <h1 className="text-2xl font-bold">{t(msg.customer.addCustomer)}</h1>

      <form className="space-y-4" onSubmit={methods.handleSubmit(onSubmit)}>
        <FancyLabelAndInput type="text" methods={methods} name="firstName" label="First Name" />
        <FancyLabelAndInput type="text" methods={methods} name="lastName" label="Last Name" />
        <FancyLabelAndInput type="email" methods={methods} name="email" label="Email Address" />
        <FancyLabelAndInput type="number" methods={methods} name="mobileNumber" label="Mobile Number" />
        <FancyLabelAndInput type="text" methods={methods} name="refNumber" label={t(msg.customer.refNumber)} />
        {/* <FancyLabelAndInput type="date" methods={methods} name="userProfileInfo.dateOfBirth" label="Date Of Birth(Optional)" /> */}
        <button className="flex-center gap-3 bg-her-blue text-white p-3 text-xl font-bold w-full rounded-md">
          {addCustomer.isPending ? <span>{t(msg.form.loading)}</span> : <span>{t(msg.form.save)}</span>}
        </button>
      </form>
    </div>
  );
}
